import React from 'react';
import styles from './FooterDivider.module.scss';

const FooterDivider = () => {
  return <div className={styles.footerDivider}/>
};

export default FooterDivider;
